import { api } from './client';

export interface UsefulContact {
  id: string;
  legacyId: number | null;
  name: string;
  contacts: string;
  comment: string | null;
  legacyLog: string | null;
  legacyLastChange: string | null;
  importedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UsefulContactAuditLog {
  id: string;
  action: 'CREATE' | 'UPDATE' | 'DELETE';
  modelName: string;
  recordId: string;
  userId: string | null;
  userName: string | null;
  dataBefore: Record<string, unknown> | null;
  dataAfter: Record<string, unknown> | null;
  diff: Record<string, { old: unknown; new: unknown }> | null;
  ip: string | null;
  userAgent: string | null;
  createdAt: string;
}

export interface SaveUsefulContactDto {
  name: string;
  contacts: string;
  comment?: string;
}

export const usefulContactsApi = {
  getAll: async (search?: string): Promise<UsefulContact[]> => {
    const { data } = await api.get('/useful-contacts', {
      params: { search: search?.trim() || undefined },
    });
    return data.items || [];
  },

  getHistory: async (id: string): Promise<{ items: UsefulContactAuditLog[]; total: number }> => {
    const { data } = await api.get(`/useful-contacts/${id}/history`);
    return data;
  },

  create: async (body: SaveUsefulContactDto): Promise<UsefulContact> => {
    const { data } = await api.post('/useful-contacts', body);
    return data;
  },

  update: async (id: string, body: SaveUsefulContactDto): Promise<UsefulContact> => {
    const { data } = await api.patch(`/useful-contacts/${id}`, body);
    return data;
  },
};
